import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GlobalScopeSelector from './GlobalScopeSelector';
export default function GlobalScopeSelectorComp({ hasTerritoriesLimitations }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(GlobalScopeSelector, { hasTerritoriesLimitations: hasTerritoriesLimitations })));
}
